import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  // 前台
  {
    path: '/index',
    redirect:'/index',
    component:()=>import('../views/icenter.vue'),
    children:[
      {
        path:'/index',
        name:'index',//首页
        component:()=>import('../views/index/index.vue'),
        
      },
      {
        path:'/about-us/about-us',//中心简介栏目
        name:'about-us',
        component:()=>import('../views/about-us/about-us.vue')
      },
      {
        path:'/about-us/leading',//领导班子栏目
        name:'leading',
        component:()=>import('../views/about-us/leading.vue')
      },
      {
        path:'/about-us/organization',//机构设置栏目
        name:'organization',
        component:()=>import('../views/about-us/organization.vue')
      },
      {
        path:'/about-us/honor',//荣誉资质栏目
        name:'honor',
        component:()=>import('../views/about-us/honor.vue')
      },
      {
        path:'/about-us/Departments',//党建文化栏目
        name:'Departments',
        component:()=>import('../views/about-us/Departments.vue')
      },
      {
        path:'/about-us/PartyDetails',//党建详情详情
        name:'PartyDetails',
        component:()=>import('../views/about-us/PartyDetails.vue')
      },
      {
        path:'/about-us/new-center',//中心动态栏目
        name:'new-center',
        component:()=>import('../views/about-us/new-center.vue')
      },
      {
        path:'/about-us/new-detail',//中心动态详情
        // path:'/about-us/new-detail/:id',//中心动态详情
        name:'new-detail',
        component:()=>import('../views/about-us/new-detail.vue')
      },
      {
        path:'/about-us/contact-us',//联系我们栏目
        name:'contact-us',
        component:()=>import('../views/about-us/contact-us.vue')
      },
      {
        path:'/digital-ecology/digital-ecology',//数字生态栏目
        name:'digital-ecology',
        component:()=>import('../views/digital-ecology/digital-ecology.vue')
      },
      {
        path:'/e-gov',//数字政府栏目
        name: 'e-gov',
        redirect: '/e-gov/wisdom-gov',
        component: () => import('../views/icenter.vue'),
        children: [
          {
            path: '/e-gov/wisdom-gov',//智慧政务
            name: 'wisdom-gov',
            component: ()=> import('../views/e-gov/wisdom-gov.vue')
          },
          {
            path: '/e-gov/core-service',//核心服务
            name: 'core-service',
            component: ()=> import('../views/e-gov/core-service.vue')
          },
          {
            path: '/e-gov/project-search',//项目研究及专利
            name: 'project-search',
            component: ()=> import('../views/e-gov/project-search.vue')
          },
          {
            path: '/e-gov/industrial',//行业标准
            name: 'industrial',
            component: ()=> import('../views/e-gov/industrial.vue')
          }
        ]
      },
      {
        path:'/job-find/job-find',//人才招聘栏目
        name:'job-find',
        component:()=>import('../views/job-find/job-find.vue')
      },
      
    ]
  },
  {
    path:"*", //系统管理
    name:'notfount',
    // component:() => import("../views/icenter.vue"), //404页面
    component:() => import("../views/error.vue"), //404页面
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  //跳转路由后,从页面顶部开始显示
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  window.pageYOffset = 0
  if(to.path === '/login'){
    next();
  }else{
    if(to.meta.isLogin){
      if(window.localStorage.getExpire("role")==="super" ){
        next()
      }else if(to.meta.needSuperLogin && window.localStorage.getExpire("role")==='user'){
    
        history.back(0)
      }else if(window.localStorage.getExpire('role') === 'user'){
     
        next()
      }else{
        next('/login')
      }
    }else{
      next()
    }
  }
})
export default router
